export default "__VITE_ASSET__23543367__"